<br>
<div class="table-container">
    <div class="spinner" *ngIf="isLoading">
        <mat-spinner color="accent"></mat-spinner>
    </div>
    <form [formGroup]="formulario" autocomplete="off">
        

        <mat-form-field appearance="fill" class="bt col-md-4">
            <mat-label>Fecha de Ingreso</mat-label>
            <input matInput [matDatepicker]="dp3" formControlName="fechaIngreso" readonly>
            <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
            <mat-datepicker touchUi #dp3 disabled="true"></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-2">
            <mat-label>Edad de Ingreso</mat-label>
            <input matInput placeholder="" readonly [value]="edadIngreso" disabled>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-2">
            <mat-label>Tiempo de Antiguedad</mat-label>
            <input matInput placeholder="" readonly [value]="tiempoDeAntiguedad" disabled>
        </mat-form-field>

        <h3>Información Complementaria</h3>
        <mat-form-field appearance="fill" class="bt col-md-12">
            <mat-label>Breve Antecedente</mat-label>
            <textarea matInput placeholder="" maxlength="300" #antecedente formControlName="desAntecedente"></textarea>
            <mat-hint align="end">{{antecedente.value.length}} / 300</mat-hint>
        </mat-form-field>

        <h3>Perfil Diagnóstico Goretti</h3>

        <div>
            <mat-form-field appearance="fill" class="bt col-md-6">
                <mat-label>Discapacidad</mat-label>
                <mat-select formControlName="idDiscapacidad" multiple #discapacidadesf>
                <mat-select-trigger>
                    {{discapacidadesf.value ? discapacidadesf.value[0] : ''}}
                    <span *ngIf="discapacidadesf.value?.length > 1" class="example-additional-selection">
                    (+{{discapacidadesf.value.length - 1}} {{discapacidadesf.value?.length === 2 ? 'más' : 'más'}})
                    </span>
                </mat-select-trigger>
                <mat-option *ngFor="let discapacidad of discapacidades" [value]="discapacidad">{{discapacidad}}</mat-option>
                </mat-select>
            </mat-form-field>      
        </div>

        <mat-form-field appearance="fill" class="bt col-md-6">
            <mat-label>Diagnóstico Neurológico</mat-label>
            <mat-select formControlName="diagnosticoNeurologico">
                <mat-option value="{{dn.idParametro}}" *ngFor="let dn of diagnosticoNeurologico">{{dn.valor}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-6">
            <mat-label>Documento Diagnóstico Neurológico</mat-label>
            <input matInput placeholder="Adjuntar JPG, PDF" [value]="archivo.value" formControlName="dnRuta" readonly>
            <button matTooltip="Click para seleccionar documento a cargar" mat-icon-button matSuffix type="button" disabled>
                <mat-icon>attach_file</mat-icon>
            </button>
            
            <input type="file" #archivo class="hide" formControlName="dnArchivo"/>
            
            <a target="_blank" rel="noopener" href="{{hostapi}}/{{documento1}}" matTooltip="Click para ver el documento cargado" color="accent" mat-icon-button matPrefix type="button" *ngIf="documento1">
                <mat-icon>download</mat-icon>
            </a>
            <mat-hint *ngIf="documento1">Ya existe un documento cargado</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-12">
            <mat-label>Descripción</mat-label>
            <textarea matInput placeholder="" maxlength="150" #descripcion formControlName="dnDescripcion"></textarea>
            <mat-hint align="end">{{descripcion.value.length}} / 150</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-6">
            <mat-label>Edad Mental</mat-label>
            <input matInput placeholder="" type="number" maxlength="2" formControlName="edadMental">
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-6">
            <mat-label>Documento Diagnóstico Neurológico</mat-label>
            <input matInput placeholder="Adjuntar JPG, PDF" [value]="archivo2.value" formControlName="dmRuta" readonly>
            <button mat-icon-button matSuffix type="button" disabled>
                <mat-icon>attach_file</mat-icon>
            </button>
            <input type="file" #archivo2 class="hide" formControlName="emArchivo"/>
            
            <a href="{{hostapi}}/{{documento2}}" *ngIf="documento2" target="_blank" rel="noopener" matTooltip="Click para ver el documento cargado" color="accent" mat-icon-button matPrefix type="button" >
                <mat-icon>download</mat-icon>
            </a>
            <mat-hint *ngIf="documento2">Ya existe un documento cargado</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-6">
            <mat-label>Diagnóstico Motríz</mat-label>
            <input matInput placeholder="" maxlength="150" #motriz formControlName="diagnosticoMotriz">
            <mat-hint align="end">{{motriz.value.length}} / 150</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-6">
            <mat-label>Documento Diagnóstico Motríz</mat-label>
            <input matInput placeholder="Adjuntar JPG, PDF" [value]="archivo3.value" formControlName="dmRuta" readonly>
            <button mat-icon-button matSuffix type="button" disabled>
                <mat-icon>attach_file</mat-icon>
            </button>
            <input type="file" #archivo3 class="hide" formControlName="dmArchivo"/>
            
            <a href="{{hostapi}}/{{documento3}}" *ngIf="documento3" target="_blank" rel="noopener" matTooltip="Click para ver el documento cargado" color="accent" mat-icon-button matPrefix type="button" >
                <mat-icon>download</mat-icon>
            </a>
            <mat-hint *ngIf="documento3">Ya existe un documento cargado</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-6">
            <mat-label>Diagnóstico Psicológico</mat-label>
            <input matInput placeholder="" maxlength="150" #psicologico formControlName="diagnosticoPsicologico">
            <mat-hint align="end">{{psicologico.value.length}} / 150</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-6">
            <mat-label>Documento Diagnóstico Psicológico</mat-label>
            <input matInput placeholder="Adjuntar JPG, PDF" [value]="archivo4.value" formControlName="dpRuta" readonly>
            <button mat-icon-button matSuffix type="button" disabled>
                <mat-icon>attach_file</mat-icon>
            </button>
            <input type="file" #archivo4 class="hide" formControlName="dpArchivo"/>
            
            <a href="{{hostapi}}/{{documento4}}" *ngIf="documento4" target="_blank" rel="noopener" matTooltip="Click para ver el documento cargado" color="accent" mat-icon-button matPrefix type="button" >
                <mat-icon>download</mat-icon>
            </a>
            <mat-hint *ngIf="documento4">Ya existe un documento cargado</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-6">
            <mat-label>Diagnóstico Médico</mat-label>
            <input matInput placeholder="" maxlength="150" #medico formControlName="diagnosticoMedico">
            <mat-hint align="end">{{medico.value.length}} / 150</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-6">
            <mat-label>Documento diagnóstico médico</mat-label>
            <input matInput placeholder="Adjuntar JPG, PDF" [value]="archivo5.value" formControlName="dmedRuta" readonly>
            <button mat-icon-button matSuffix type="button" disabled>
                <mat-icon>attach_file</mat-icon>
            </button>
            <input type="file" #archivo5 class="hide" formControlName="dmedArchivo"/>
            
            <a href="{{hostapi}}/{{documento5}}" *ngIf="documento5" target="_blank" rel="noopener" matTooltip="Click para ver el documento cargado" color="accent" mat-icon-button matPrefix type="button" >
                <mat-icon>download</mat-icon>
            </a>
            <mat-hint *ngIf="documento5">Ya existe un documento cargado</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-6">
            <mat-label>Tipo de Sangre</mat-label>
            <mat-select formControlName="tipoDeSangre">
                <mat-option *ngFor="let tipo of tipoDeSangre" value="{{tipo.idParametro}}">{{tipo.valor}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-6">
            <mat-label>Documento Tipo de Sangre</mat-label>
            <input matInput placeholder="Adjuntar JPG, PDF" [value]="archivo6.value" formControlName="tsRuta" readonly>
            <button mat-icon-button matSuffix type="button" disabled>
                <mat-icon>attach_file</mat-icon>
            </button>
            <input type="file" #archivo6 class="hide" formControlName="tsArchivo"/>

            <a href="{{hostapi}}/{{documento6}}" *ngIf="documento6" target="_blank" rel="noopener" matTooltip="Click para ver el documento cargado" color="accent" mat-icon-button matPrefix type="button" >
                <mat-icon>download</mat-icon>
            </a>
            <mat-hint *ngIf="documento6">Ya existe un documento cargado</mat-hint>
        </mat-form-field>
        <br>
        
        <mat-label>Condición Relevante</mat-label>
        &nbsp;
        <mat-radio-group aria-label="Condición relevante" formControlName="condicionRelevante">
            <mat-radio-button value="si">Si</mat-radio-button>
            <mat-radio-button value="no">No</mat-radio-button>
        </mat-radio-group>
        &nbsp;

        <mat-form-field appearance="fill" class="bt col-md-6">
            <input matInput placeholder="" maxlength="100" #descripcion2 formControlName="condicionRelevanteDescription">
            <mat-hint align="end">{{descripcion2.value.length}} / 100</mat-hint>
        </mat-form-field>

        <div style="display: none;">
            <h3>Desarrollo</h3>
            <div class="bt col-md-4">
                <h4>Necesidades de Apoyo Cognitivas</h4>
                <mat-form-field appearance="fill" class="bt col-md-12">
                    <mat-label></mat-label>
                    <mat-select formControlName="autonomiaCognitivoSelect" readonly>
                        <mat-option value="{{dn.idParametro}}" *ngFor="let dn of autonomiasConitivas">{{dn.valor}}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill" class="bt col-md-12">
                    <mat-label>Descripción</mat-label>
                    <input matInput formControlName="autonomiaCognitivoInput" readonly>
                </mat-form-field>
            </div>

            <div class="bt col-md-4">
                <h4>Necesidades de Apoyo Motriz</h4>
                <mat-form-field appearance="fill" class="bt col-md-12">
                    <mat-label></mat-label>
                    <mat-select formControlName="autonomiaMotrizSelect" readonly>
                        <mat-option value="{{dn.idParametro}}" *ngFor="let dn of autonomiasConitivas">{{dn.valor}}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill" class="bt col-md-12">
                    <mat-label>Descripción</mat-label>
                    <input matInput formControlName="autonomiaMotrizInput" readonly>
                </mat-form-field>
            </div>

            <div class="bt col-md-4">
                <h4>Diagnóstico Emocional</h4>
                <mat-form-field appearance="fill" class="bt col-md-12">
                    <mat-label></mat-label>
                    <mat-select formControlName="diagnosticoEmocionalSelect" readonly>
                        <mat-option value="{{dn.idParametro}}" *ngFor="let dn of autonomiasConitivas">{{dn.valor}}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill" class="bt col-md-12">
                    <mat-label>Descripción</mat-label>
                    <input matInput formControlName="diagnosticoEmocionalInput" readonly>
                </mat-form-field>
            </div>
        </div>

        <div class="text-align-center">
            <button mat-flat-button color="primary" class="flat" type="button" [routerLink]="['/beneficiarias']">Cancelar</button>
        </div>
    </form>
</div>